module.exports = __webpack_public_path__ + "media/images/favicon-948205c6f38584e9c0a197c340b0e1dc.ico";